import { Paper as MUIPaper, PaperProps } from '@mui/material';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';

interface Props extends PaperProps {}

export const FormContainer: FunctionComponent<Props> = ({ sx, ...props }) => {
	return (
		<MUIPaper
			sx={{
				width: '503px',
				padding: '56px 45px',
				backgroundColor: ColorPalette.white,
				boxShadow: 'none',
				borderRadius: '20px',
				position: 'relative',
				...sx,
			}}
			{...props}
		>
			{props.children}
		</MUIPaper>
	);
};
